import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Translate from 'react-translate-component';
import { Button, Col, Row, Spin } from 'antd';
import { Field } from 'react-final-form';
import * as yup from 'yup';

import ErrorHTML from 'components/common/form/ErrorHTML';
import withAutoFocusForm from 'components/hocs/withAutoFocusForm';
import Text from 'components/common/form/Text';
import withFormWrapper from 'components/hocs/withFormWrapper';

const validationSchema = yup.object().shape({
	comment: yup.string().required()
});

@withAutoFocusForm
@withFormWrapper({
	validationSchema,
	mapPropsToValues: props => ({
		draft: false,
		vacancy: props.id
	})
})
export default class ApplicationForm extends Component {
    static propTypes = {
        handleSubmit: PropTypes.func.isRequired,
        formAction: PropTypes.object.isRequired,
        id: PropTypes.number,
    }

    render () {
        const { handleSubmit, formAction: { meta } } = this.props;

        return (
            <Spin spinning={meta.pending}>
                <div className='comment-form'>
                    <Field name='comment'
                        component={Text}
                        autoSize={{ minRows: 10, maxRows: 20 }}
                        placeholder='placeholders.application'
                    />

                    <Row>
                        <Col xs={{ span: 12 }} className="alert-inline">
                            <ErrorHTML meta={meta} />
                        </Col>
                        <Col xs={{ span: 12 }} className="text-right">
                            <Button htmlType='submit' type='blue' onClick={handleSubmit}>
                                <Translate content={`button.send`} />
                            </Button>
                        </Col>
                    </Row>
                </div>
            </Spin>
        );
    }
}
